import { z } from 'zod';
import {
    emailBodyValidation,
    emailDelayUnitValidation,
    emailDelayValidation,
    emailDelayValidationStrict,
    emailSubjectValidation,
    getDelayRangeErrorMessage,
    validateDelayRange,
} from '../../validations/sharedEmailValidations';

/**
 * Base email form schema (shared fields)
 */
const baseEmailFormSchema = {
    subject: emailSubjectValidation,
    body: emailBodyValidation,
    delayUnit: emailDelayUnitValidation,
};

/**
 * Email form validation schema for drafts
 * Allows empty delay values for saving as draft
 */
export const emailFormSchemaDraft = z
    .object({
        ...baseEmailFormSchema,
        delay: emailDelayValidation,
    })
    .refine(
        data => {
            // Skip validation if delay is empty/0 (allowed for drafts)
            if (!data.delay || data.delay === '' || data.delay === '0') return true;

            return validateDelayRange(data);
        },
        data => getDelayRangeErrorMessage(data)
    );

/**
 * Email form validation schema for publishing
 * Requires delay value to be provided
 */
export const emailFormSchemaPublish = z
    .object({
        ...baseEmailFormSchema,
        delay: emailDelayValidationStrict,
    })
    .refine(
        data => validateDelayRange(data),
        data => getDelayRangeErrorMessage(data)
    );

/**
 * Default schema (for form initialization) - uses draft schema
 */
export const emailFormSchema = emailFormSchemaDraft;

/**
 * Infer the TypeScript type from the schema
 */
export type EmailFormData = z.infer<typeof emailFormSchema>;
